module.exports = __webpack_public_path__ + "static/logistics-82b26af875e55baa27dcb4be3547324c.jpg";